import { useOpstelClient } from "@opstel/contexts/opstelClient/useOpstelClient";
import { aboutInfoSchema } from "@opstel/query/v2/models/aboutInfo";
import { useQuery } from "@tanstack/react-query";

export function useAboutInfoQuery() {
  const { opstelClient } = useOpstelClient();

  return useQuery({
    queryKey: ["about"],
    queryFn: async () => await opstelClient.getAboutInfo(),
    select: (data) => aboutInfoSchema.parse(data),
  });
}
